<md-dialog>
	<div md-dialog-header>
		<md-icon icon="untitled-ui/general/check-verified-03"></md-icon>
		<span class="md-text-lg-semibold">Complete Semester</span>
	</div>

	<div class="dialog-content">
		<!-- Warning Banner -->
		<md-content-box type="warning" padding="md" class="warning-banner">
			<div class="warning-banner__text">
				<span class="md-text-sm-semibold">You have 5 days to submit the final semester grade.</span>
			</div>
		</md-content-box>

		@if (hasProjectCriteria()) {
			<div class="review-section">
				<span class="review-section__label review-section__label--strong">Project Criteria</span>
				<div class="review-section__content">
					@for (item of projectCriteriaItems(); track item.criteriaName) {
						<div class="grade-row">
							<span class="grade-row__category">{{ item.criteriaName }}</span>
							@if (item.gradeName) {
								<lb-grade-tag [grade]="item.gradeName" [type]="item.gradeColor"></lb-grade-tag>
							} @else {
								<span class="grade-row__empty">—</span>
							}
						</div>
					}
				</div>
			</div>
		}

		<lb-divider></lb-divider>

		<!-- Project Final Grade -->
		@if (projectGrade(); as project) {
			<div class="review-section overall-grade-section">
				<span class="review-section__label review-section__label--strong">Project Final Grade</span>
				<div class="overall-grade-display">
					@if (project.gradeName) {
						<lb-grade-tag [grade]="project.gradeName" [type]="project.gradeColor"></lb-grade-tag>
					} @else {
						<span class="grade-row__empty">—</span>
					}
				</div>
			</div>
		}

		<!-- Attendance Section -->
		<div class="review-section attendance-section">
			<span class="review-section__label"> Attendance <md-tag type="success">Present</md-tag> </span>
			@if (!isAttendanceTaken() && isAdmin()) {
				<label class="invoice-option">
					<input md-form-input type="checkbox" [checked]="generateInvoice()" (change)="generateInvoice.set($any($event.target).checked)" />
					<span class="md-text-sm-regular">Generate an invoice line item for this lesson.</span>
				</label>
			}
		</div>
	</div>

	<div md-dialog-footer>
		<button md-button (click)="close()">Cancel</button>
		<button md-button-brand (click)="confirm()">Save</button>
	</div>
</md-dialog>
